var _ref2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPerson = function SvgPerson(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      d: "M17.0303 7.75855C17.0303 10.3861 14.9003 12.5161 12.2727 12.5161C9.64519 12.5161 7.51515 10.3861 7.51515 7.75855C7.51515 5.13102 9.64519 3.00098 12.2727 3.00098C14.9003 3.00098 17.0303 5.13102 17.0303 7.75855ZM16.7082 17.5655C17.6462 18.5035 18.2565 19.708 18.4653 21.001H6.0802C6.28899 19.708 6.89924 18.5035 7.83723 17.5655L7.13013 16.8584L7.83724 17.5655C9.01359 16.3891 10.6091 15.7282 12.2727 15.7282C13.9364 15.7282 15.5319 16.3891 16.7082 17.5655L17.4153 16.8584L16.7082 17.5655Z",
      stroke: "#041F47",
      strokeWidth: 2
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgPerson, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/person.e1849ddd.svg";
export { ForwardRef as ReactComponent };